<div class="form" *appCalendarAppContext>
  <div class="form-date">{{ calendar?.createdAt | dateFormat : 'date' }}</div>

  <h2 class="form-title">
    <app-icon
      class="form-heading-title-icon"
      name="calendar"
      [style.color]="calendar?.color"
    />
    {{ calendar?.title }}
  </h2>

  @if (calendar) {
    <app-shared-tags
      class="form-tags"
      [stitchItem]="calendar"
      [stateKey]="StateKey.tagsList"
    />

    <app-shared-knots
      class="form-knots"
      [stitchItem]="calendar"
      [stateKey]="StateKey.knotsList"
    />
  }

  <app-shared-signup-cta />

  <div class="form-details">
    <div class="form-details-row">
      <div class="form-details-row-title">Parent Calendar</div>
      <div class="form-details-row-input">{{ calendar?.parentId }}</div>
    </div>

    <div class="form-details-row">
      <div class="form-details-row-title">Description</div>
      <stch-item-description class="form-details-row-input" stchHighlightText [html]="calendar?.description" />
    </div>

  </div>
</div>
